export enum Flags {
    GpsUnderworked = "gps_underworked",
    GpsOverworked = "gps_overworked",
    Testing = "testing",
    Forceplate = "forceplate",
    UserDefined = "user_defined"
}

export const HOURS_IN_DAY = 24;
export const HOURS_IN_WEEK = HOURS_IN_DAY * 7
export const HOURS_IN_MONTH = HOURS_IN_DAY * 30
export const HOURS_IN_SIX_MONTHS = HOURS_IN_MONTH * 6

export const flagTypesOptions: {
    label: string;
    value: Flags
}[] = [
    {
        label: "GPS Underworked",
        value: Flags.GpsUnderworked
    },
    {
        label: "GPS Overworked",
        value: Flags.GpsOverworked
    },
    {
        label: "Testing",
        value: Flags.Testing
    },
    {
        label: "Forceplate",
        value: Flags.Forceplate
    },
    {
        label: "User Defined",
        value: Flags.UserDefined
    }
]

export interface IFlagReminderData {
    id?: number
    reminder_time: string;
    lookback_hours: number;
    metadata: {
        flag_types: Flags[],
        recipients: string[],
        individual_metrics?: string[],   // only present if flag type testing or forceplate
        user_defined_flag_ids?: number[],   // only present if flag type user defined
    },
    last_sent_at?: string,
    next_due_at: string,
    is_active: boolean,
    team?: number,
    creator?: number
}

export interface IFocusedMetrics {
    is_percentage: boolean;
    key: string;
    low_good: boolean;
    metadata: object;
    metric_id: number;
    metric_type: string;
    name: string;
    num_decimals: number;
    unique_identifier: string;
}